import React, { Component } from 'react';
import { PropTypes } from 'mobx-react';

import JobOfferBox from './JobOfferBox/JobOfferBox';
import { createSlug } from 'common/utils/utils';

export default class JobOffersList extends Component {
  static propTypes = {
    jobOffers: PropTypes.observableArray
  };

  render() {
    return (
      <div>
        {this.props.jobOffers.map(jobOffer => (
          <JobOfferBox
            key={jobOffer.id}
            id={jobOffer.id}
            slug={createSlug(jobOffer.title, jobOffer.id)}
            name={jobOffer.title}
            cities={jobOffer.jobLocation.split(',')}
            logo={jobOffer.logo}
            isArticleView={this.props.isArticleView}
          />
        ))}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/common/components/JobOffersList/JobOffersList.js